var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 60,
    viewBox: "0 0 56 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00001 40.3571C8.18954 40.3571 9.15385 41.3165 9.15385 42.5V50C9.15385 51.7303 10.4264 52.8572 11.6667 52.8572H44.3333C45.5736 52.8572 46.8462 51.7303 46.8462 50V42.5C46.8462 41.3165 47.8105 40.3571 49 40.3571C50.1895 40.3571 51.1539 41.3165 51.1539 42.5V50C51.1539 53.7926 48.2477 57.1429 44.3333 57.1429H11.6667C7.75227 57.1429 4.84616 53.7926 4.84616 50V42.5C4.84616 41.3165 5.81047 40.3571 7.00001 40.3571Z",
    fill: "#5FBDD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2011 28.4297C18.0728 27.6244 19.4356 27.6747 20.245 28.5419L28 36.8508L35.755 28.5419C36.5644 27.6747 37.9272 27.6244 38.7989 28.4297C39.6706 29.235 39.7211 30.5909 38.9116 31.4581L29.5783 41.4581C29.1708 41.8948 28.5989 42.1429 28 42.1429C27.4011 42.1429 26.8292 41.8948 26.4217 41.4581L17.0883 31.4581C16.2789 30.5909 16.3294 29.235 17.2011 28.4297Z",
    fill: "#5FBDD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 2.85715C29.1895 2.85715 30.1539 3.81654 30.1539 5V40C30.1539 41.1835 29.1895 42.1429 28 42.1429C26.8105 42.1429 25.8462 41.1835 25.8462 40V5C25.8462 3.81654 26.8105 2.85715 28 2.85715Z",
    fill: "#5FBDD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1e2e9f7333725698a06e54a5a0a497d4.svg";
export { ForwardRef as ReactComponent };